import React from "react";

const BackArrow = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 35 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.83594 17.5L4.80474 16.4688L3.77354 17.5L4.80474 18.5312L5.83594 17.5ZM27.7109 18.9583C28.5164 18.9583 29.1693 18.3054 29.1693 17.5C29.1693 16.6946 28.5164 16.0417 27.7109 16.0417V17.5V18.9583ZM14.5859 8.75L13.5547 7.7188L4.80474 16.4688L5.83594 17.5L6.86713 18.5312L15.6171 9.7812L14.5859 8.75ZM5.83594 17.5L4.80474 18.5312L13.5547 27.2812L14.5859 26.25L15.6171 25.2188L6.86713 16.4688L5.83594 17.5ZM5.83594 17.5V18.9583H27.7109V17.5V16.0417H5.83594V17.5Z"
        fill="#33363F"
      />
    </svg>
  );
};

export default BackArrow;
